import {
	UntypedFormArray,
	UntypedFormGroup,
	UntypedFormControl,
} from '@angular/forms';

export const DATA_TYPE_DATE: string = 'datetype';
export const DATA_TYPE_STRING: string = 'texttype';

export interface CustomReportFieldJSON {
	id: number;
	fieldName: string;
	fieldAlias: string;
	fieldDataType: string;
}

export class CustomReportField {
	constructor(
		public id: number,
		public fieldName: string,
		public fieldAlias: string,
		public fieldDataType: string
	) {}

	static fromJSON(json: CustomReportFieldJSON): CustomReportField {
		return Object.assign(
			Object.create(CustomReportField.prototype),
			json,
			{}
		);
	}

	static createFormArray(
		tableFields: CustomReportField[],
		selectedFields: string[]
	): UntypedFormArray {
		return tableFields
			? new UntypedFormArray(
					tableFields.map((field) =>
						this.createFormGroup(field, selectedFields)
					)
				)
			: new UntypedFormArray([]);
	}

	static createFormGroup(
		field: CustomReportField,
		selectedFields: string[]
	): UntypedFormGroup {
		return new UntypedFormGroup({
			selected: new UntypedFormControl(
				!!selectedFields?.find((sf) => sf === field.fieldName)
			),
			name: new UntypedFormControl(field.fieldName),
			alias: new UntypedFormControl(field.fieldAlias),
		});
	}

	static convertFieldNameToAlias(
		fieldName: string,
		fields: CustomReportField[]
	): string {
		const matchingField = this.findFieldByName(fieldName, fields);
		return matchingField ? matchingField.fieldAlias : null;
	}

	static findFieldByName(
		name: string,
		fields: CustomReportField[]
	): CustomReportField {
		return fields ? fields.find((field) => field.fieldName === name) : null;
	}

	static findFieldDataType(
		name: string,
		fields: CustomReportField[]
	): string {
		const field: CustomReportField = this.findFieldByName(name, fields);
		return field ? field.fieldDataType : null;
	}

	static getSelectedFieldNames(fg: UntypedFormGroup): string[] {
		return this.getSelectedFormGroupValues(fg).map((field) => field.name);
	}

	private static getSelectedFormGroupValues(fg: UntypedFormGroup): {
		selected: boolean;
		name: string;
		alias: string;
	}[] {
		return this.getFormGroupValues(fg).filter((value) => value.selected);
	}

	private static getFormGroupValues(fg: UntypedFormGroup): {
		selected: boolean;
		name: string;
		alias: string;
	}[] {
		return fg.value['fields'];
	}
}
